import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { XCircle, Zap, RefreshCw, Edit3 } from 'lucide-react';

export default function FailurePage() {
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('ref');
  const orderId = searchParams.get('order_id');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0A0A0A' }}>
      <div className="max-w-[440px] mx-auto px-4 pt-12 pb-8">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-7 h-7 rounded bg-gradient-to-br from-[#D4A843] to-[#B8923A] flex items-center justify-center">
            <Zap size={13} className="text-[#120F08]" />
          </div>
          <span className="font-['EB_Garamond'] text-[#F2F2F2] text-lg font-semibold">Scratch Unleashed</span>
        </div>

        <div className="text-center mb-6">
          <div className="w-16 h-16 rounded-full border-2 border-[#E05252] flex items-center justify-center mx-auto mb-4">
            <XCircle size={32} className="text-[#E05252]" />
          </div>
          <h1 className="font-['EB_Garamond'] text-3xl text-[#F2F2F2] mb-1">Payment Failed</h1>
          <p className="text-[#B9B9B9] text-sm">Your payment could not be processed. Please try again.</p>
        </div>

        <div className="surface-card card-highlight rounded-xl p-5 space-y-3 mb-6">
          {ref && (
            <div className="flex items-center justify-between text-sm">
              <span className="text-[#B9B9B9]">Booking Ref</span>
              <span className="text-mono text-[#D4A843]">{ref}</span>
            </div>
          )}
          {orderId && (
            <div className="flex items-center justify-between text-sm">
              <span className="text-[#B9B9B9]">Order ID</span>
              <span className="text-mono text-[#6F6F6F] text-xs">{orderId}</span>
            </div>
          )}
          <div className="bg-[#2A1414] border border-[#4A1F1F] rounded-lg p-3">
            <p className="text-[#FFD7D7] text-sm">Your check-in record is saved. You can retry payment anytime.</p>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            onClick={() => navigate(`/checkin/pay?order_id=${orderId}&ref=${ref}`)}
            className="w-full btn-gold rounded-xl h-11 font-semibold flex items-center gap-2"
          >
            <RefreshCw size={15} /> Retry Payment
          </Button>
          <Button
            onClick={() => navigate('/checkin')}
            variant="outline"
            className="w-full rounded-xl h-11 bg-[#1A1A1A] border-[#2A2A2A] text-[#F2F2F2] hover:border-[#D4A843]/40 flex items-center gap-2"
          >
            <Edit3 size={15} /> New Check-in
          </Button>
        </div>
      </div>
    </div>
  );
}
